/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./VoiceCallButton.module.css"
import {ReactComponent as DialerIcon} from "./dialer.svg"
import {Auth} from "types/auth"
import {useContext} from "react"
import {DialerStudent, VoiceCallContext} from "context/VoiceCallContext"
import {getFullName} from "helpers"
import cx from "classnames"

type Props = {
    studentProfileId?: number
    studentData?: Auth.UserProfile
    departmentId?: number
}

export function VoiceCallButton({studentData, departmentId, studentProfileId}: Props) {
    const {calling, startCall, setActiveStudent, setActiveDepartmentId} = useContext(VoiceCallContext)

    const phone = studentData?.phones.filter((p) => p.isPrimary)[0]?.phone
    const email = studentData?.emails.filter((e) => e.isPrimary)[0]?.email
    const studentInfo: DialerStudent = {
        userId: studentData?.id,
        profileId: studentProfileId,
        fullName: getFullName(studentData),
        email,
        phone
    }

    const handleStartCall = () => {
        if (calling) return
        setActiveStudent(studentInfo)
        setActiveDepartmentId(departmentId)
        startCall(studentInfo, departmentId)
    }

    return (
        <div className={cx(styles.btnWrap, {[styles.disabled]: calling})} onClick={handleStartCall}>
            <DialerIcon className={styles.icon} />
            <span className={styles.title}>Voice Call</span>
        </div>
    )
}
